export const WIDTH_MAX = 1920;
export const HEIGHT_MAX = 1080;
export const WIDTH_NAVIGATION_VIEW = 156;
